import { COLLECTION_DETAILS_STATUSES_MAP, CollectionDetailsStatus } from '../VehicleCollectionSubjects';

export const shouldShowMarkAsCollectedActionCenter = (
  status: CollectionDetailsStatus,
): boolean => status === COLLECTION_DETAILS_STATUSES_MAP.INSPECTION_COMPLETED;
